<!-- 4/6/2026 Doing -->

<div *ngIf="realms.length; else loading" class="company-dropdown" [dataTestID]="'company-dropdown'">
  <div
    [class.dropdown-custom-quickbook]="isCreateQuickBook"
    class="dropdown drp-user position-relative"
    ngbDropdown
    placement="auto"
  >
    <a
      class="nav-link dropdown-toggle position-absolute d-flex align-items-center justify-content-around"
      id="resourcesDropdown"
      role="button"
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <ng-container *ngIf="selectedRealm?.companyType">
        <ng-container *ngIf="selectedRealm?.companyType | companyLogoInline as inlineSvg; else selectedImgLogo">
          <span class="company-dropdown__realm__logo d-flex align-items-center" [innerHTML]="inlineSvg"></span>
        </ng-container>
        <ng-template #selectedImgLogo>
          <img class="company-dropdown__realm__logo d-flex align-items-center" [src]="selectedRealm?.companyType | companyLogo | safe" alt="Company Logo">
        </ng-template>
      </ng-container>
      <span class="px-2"> {{ selectedRealm?.companyName }} </span>
      <i
        *ngIf="!isCreateQuickBook"
        [style]="{ 'font-size': '12px' }"
        class="fas fa-chevron-down"
      ></i>
    </a>
    <div
      [class.dropdown-menu-custom-quickbook]="isCreateQuickBook"
      class="dropdown-menu dropdown-menu-right profile-notification dropdown-menu-custom"
      ngbDropdownMenu
    >
      <ul class="pro-body py-2">
        <li
          *ngFor="let realm of realms; let index = index"
          class="p-2 cursor-pointer"
          [class.disabled]="selectedRealm?.companyKey === realm?.companyKey"
          [dataTestID]="
            index === 0 ? 'add-company-option' : realm?.companyName + '-option'
          "
          (click)="switchRealms(realm)"
        >
          <div class="company-dropdown__realm">
            <ng-container *ngIf="realm?.companyType">
              <ng-container *ngIf="realm?.companyType | companyLogoInline as inlineSvg; else realmImgLogo">
                <span class="company-dropdown__realm__logo" [innerHTML]="inlineSvg"></span>
              </ng-container>
              <ng-template #realmImgLogo>
                <img class="company-dropdown__realm__logo" [src]="realm?.companyType | companyLogo | safe" alt="Company Logo">
              </ng-template>
            </ng-container>

            <span>{{ realm?.companyName }}</span>

            <span *ngIf="realm?.companyType === CompanyType.ASC">
              ({{ realm?.marketplaceName }})
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
<ng-template #loading>
  <div class="nav-item dropdown">
    <span
      class="nav-link dropdown-toggle"
      id="resourcesDropdown"
      role="button"
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span> Loading Companies... </span>
      <i [style]="{ 'font-size': '12px' }" class="fas fa-chevron-down ml-1"></i>
    </span>
  </div>
</ng-template>
